const POSTHOG_KEY = 'phc_xJvj5sapWBaTqhcr72icHZv8Fn5XVAekodczAbxriX9w';
const POSTHOG_HOST = 'https://us.i.posthog.com';

let posthogInstance: any = null;

/**
 * Heuristic: returns true when the current route is a public/unauthenticated
 * surface (landing, blog, public academy/course/product/session pages).
 * Used to disable session recording on these heavy public pages where rrweb
 * would otherwise inflate TBT/main-thread time.
 *
 * Authenticated app shells (/student, /instructor, /admin, /post-login,
 * /checkout, /payment, /login, /signup) get full PostHog recording behavior.
 */
function isPublicRoute(): boolean {
  if (typeof window === 'undefined') return true;
  const path = window.location.pathname || '/';
  const PRIVATE_PREFIXES = [
    '/student', '/instructor', '/admin',
    '/post-login', '/checkout', '/payment',
    '/login', '/signup', '/auth',
  ];
  return !PRIVATE_PREFIXES.some((p) => path === p || path.startsWith(p + '/') || path.startsWith(p));
}

export async function initPostHog() {
  if (typeof window !== 'undefined') {
    const { default: posthog } = await import('posthog-js');
    const publicRoute = isPublicRoute();
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      person_profiles: 'identified_only',
      capture_pageview: true,
      capture_pageleave: true,
      // Keep autocapture (lightweight) but disable session recording on
      // public/unauthenticated routes to avoid loading rrweb on landing pages.
      autocapture: true,
      disable_session_recording: publicRoute,
    });
    posthogInstance = posthog;
  }
}

export const posthog = new Proxy({} as any, {
  get(_target, prop) {
    if (posthogInstance) return posthogInstance[prop];
    return () => {};
  },
});
